// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import { formatCurrency } from "../../../utils"
import Division from "../../../components/Division"
import { formatDate, translationFunction } from "../../../utils"
import _ from "lodash"
import * as strings from "../../../strings"

export default class Verfication extends Component {
  props: {
    paymentAgreementState: any,
    onChange: any,
    procedures: any,
    debt: any,
  }

  componentDidMount = () => {
    window.scrollTo( 0, 0 )
  }

  checkContactField = ( debtDebtor, field ) => {
    const { generalStrings } = strings
    return _.get( debtDebtor, "debtor.contact." + field ) || generalStrings.emptyField
  }

  renderDebtor = () => {
    const { generalStrings } = strings
    const { debt, paymentAgreementState } = this.props
    let debtDebtor

    if ( this.props.debt.length !== 0 ) {
      debtDebtor = debt.debtDebtors.find( debtDebtor =>
        debtDebtor.idDebtor === paymentAgreementState.debtorChecked )
    }

    return (
      <div className={style.clientInfoIsland}>
        <div className={style.blueBar}>
        </div>
        <div className={style.clientInfo}>
          <Division title={strings.debtor.title.toUpperCase()} />
          <div className={style.gridDebtor}>
            <div className={style.bottomColumn}>
              <p className={style.tableTitle}>{strings.debtor.name}</p>
              <p className={style.tableContent}>{this.checkContactField( debtDebtor, "name" )}</p>
            </div>

            <div className={style.bottomColumn}>
              <p className={style.tableTitle}>{generalStrings.documentType}: {translationFunction( this.checkContactField( debtDebtor, "documentType" ) )}</p>
              <p className={style.tableContent}>{this.checkContactField( debtDebtor, "documentNumber" )}</p>
            </div>

            <div className={style.bottomColumn}>
              <p className={style.tableTitle}>{strings.debtor.nif}</p>
              <p className={style.tableContent}>{this.checkContactField( debtDebtor, "nif" )}</p>
            </div>

            <div className={style.bottomColumn}>
              <p className={style.tableTitle}>{strings.debtor.address}</p>
              <p className={style.tableContent}>{this.checkContactField( debtDebtor, "address" )}</p>
            </div>

            <div className={style.bottomColumn}>
              <p className={style.tableTitle}>{strings.debtor.local}</p>
              <p className={style.tableContent}>{this.checkContactField( debtDebtor, "city" )}</p>
            </div>

            <div className={style.bottomColumn}>
              <p className={style.tableTitle}>{strings.debtor.zipCode}</p>
              <p className={style.tableContent}>{this.checkContactField( debtDebtor, "zipCode" )}</p>
            </div>

            <div className={style.bottomColumn}>
              <p className={style.tableTitle}>{strings.debtor.phone}</p>
              <p className={style.tableContent}>{this.checkContactField( debtDebtor, "phone" )}</p>
            </div>

            <div className={style.bottomColumn}>
              <p className={style.tableTitle}>{strings.debtor.email}</p>
              <p className={style.tableContent}>{this.checkContactField( debtDebtor, "email" )}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderDebtInvoices = ( debtsArray, invoicesArray ) => {
    return (
      debtsArray.map( ( debt, i ) => {
        const { activeOption } = debt

        if ( _.flatten( invoicesArray[ i ] ).length !== 0 ) {
          return null
        }

        return (
          <tbody key={i}>
            <tr className={style.borderBottom}>
              <td className={style.tdFirst}>{strings.generalStrings.idc} {debt.idc}</td>
              <td className={style.tdFirst}>{activeOption.state ? activeOption.state.name : "--" }</td>
              <td className={style.tdFirst}>{activeOption.subtype ? activeOption.subtype.name : "--" }</td>
              <td className={style.tdFirst}>{activeOption.type ? activeOption.type.name : "--" }</td>
              <td className={style.tdFirst}></td>
            </tr>
            { _.flatten( invoicesArray[ i ] ).map( ( invoice, a ) =>
              <tr key={a} >
                <td className={style.tdTableFirst}></td>
                <td className={style.tdTable}>{strings.invoices.invoice.toUpperCase()} {invoice.documentNumber}</td>
                <td className={style.tdTable}>{invoice.value}<b>{strings.generalStrings.currency}</b></td>
                <td className={style.tdTable}>{formatDate( invoice.date )}</td>
                <td className={style.tdTable}>{formatDate( invoice.expiryDate )}</td>
              </tr>
            ) }
          </tbody>
        )
      }
      )
    )
  }

  renderAddedInvoices = ( addedInvoices ) => {
    if ( addedInvoices.length === 0 ) {
      return null
    }
    return (
      <tbody>
        <tr className={style.borderBottom}>
          <td className={style.tdFirst}>{strings.invoices.addedInvoices.toUpperCase()}</td>
          <td className={style.tdFirst}></td>
          <td className={style.tdFirst}></td>
          <td className={style.tdFirst}></td>
          <td className={style.tdFirst}></td>
        </tr>
        {addedInvoices.map( ( newInvoice, i ) =>
          <tr key={i} >
            <td className={style.tdTable}></td>
            <td className={style.tdTable}>{strings.invoices.invoice.toUpperCase()} {newInvoice.documentNumber}</td>
            <td className={style.tdTable}>{newInvoice.value.toFixed( 2 )}<b>{strings.generalStrings.currency}</b></td>
            <td className={style.tdTable}>{formatDate( newInvoice.date )}</td>
            <td className={style.tdTable}>{formatDate( newInvoice.expiryDate )}</td>
          </tr> )}
      </tbody>
    )
  }

  renderInvoices = ( preLitigationFilteredArray, preLitigationInvoices,
    litigationFilteredArray, litigationInvoices ) => {
    const { paymentAgreementState } = this.props
    return (
      <div className={style.invoicesIsland}>
        <div className={style.greyLine}>
        </div>
        <div className={style.invoicesInfo}>
          <div className={style.clientInfoContainer}>
            <table className={style.tableCss}>
              <thead>
                <tr>
                  <td className={style.tabTitle}>{strings.invoices.details}</td>
                  <td className={style.tabTitle}>{strings.generalStrings.documentNumber}</td>
                  <td className={style.tabTitle}>{strings.invoices.value}</td>
                  <td className={style.tabTitle}>{strings.invoices.emissionDate}</td>
                  <td className={style.tabTitle}>{strings.invoices.expiryDate}</td>
                </tr>
              </thead>
              {this.renderDebtInvoices( preLitigationFilteredArray, preLitigationInvoices )}
              {this.renderDebtInvoices( litigationFilteredArray, litigationInvoices )}
              {this.renderAddedInvoices( paymentAgreementState.addedInvoices )}
            </table>
          </div>
        </div>
      </div>
    )
  }

  renderPaymentAgreement = () => {
    return (
      <div className={style.paymentsIsland}>
        <div className={style.paymentsInfo}>
          <Division title={strings.paymentAgreements.paymentAgreementTitle.toUpperCase()}/>
          <div className={style.clientInfoContainer}>
            <table className={style.paymentsTable}>
              <thead>
                <tr className={style.border}>
                  <td className={style.tabTitle}>{strings.paymentAgreements.numberOfPayments}</td>
                  <td className={style.tabTitle}>{strings.paymentAgreements.limitDate}</td>
                  <td className={style.tabTitle}>{strings.paymentAgreements.paymentValue}</td>
                </tr>
              </thead>
              <tbody>
                {_.times( this.props.paymentAgreementState.payments.length, i =>
                  <tr key={i}>
                    <td className={style.tableTitle}>{ i + 1 }</td>
                    <td className={style.tableTitle}>{formatDate(
                      this.props.paymentAgreementState.paymentDates[ i ] )}</td>
                    <td className={style.tableTitle}>{this.props.paymentAgreementState.payments[ i ].
                      toFixed( 2 )}<b>{strings.generalStrings.currency}</b></td>
                  </tr>
                ) }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }

  renderPaymentInfo = () => {
    const { paymentAgreementState } = this.props
    return (
      <div className={style.paymentAgreementIsland}>
        <div className={style.greyLine}>
        </div>
        <div className={style.paymentAgreementInfo}>
          <div className={style.clientInfoContainer}>
            <div className={style.bottomColumn}>
              <p className={style.tableTitle}>{strings.paymentAgreements.capitalValue}</p>
              <p className={style.tableContent}>{formatCurrency(
                paymentAgreementState.capitalValue )}</p>
            </div>

            <div className={style.bottomColumn}>
              <p className={style.tableTitle}>{strings.paymentAgreements.agreedValue}</p>
              <p className={style.tableContent}>{formatCurrency( paymentAgreementState.debtValue )}</p>
            </div>

            <div className={style.bottomColumn}>
              <p className={style.tableTitle}>{strings.paymentAgreements.interestValue}</p>
              <p className={style.tableContent}>{paymentAgreementState.interestValue ?
                formatCurrency( paymentAgreementState.interestValue ) : 0 + strings.generalStrings.currency} </p>
            </div>

            <div className={style.bottomColumn}>
              <p className={style.tableTitle}>{strings.paymentAgreements.justiceTax}</p>
              <p className={style.tableContent}>{paymentAgreementState.justiceTax ?
                formatCurrency( paymentAgreementState.justiceTax ) : 0 + strings.generalStrings.currency}</p>
            </div>

            <div className={style.bottomColumn}>
              <p className={style.tableTitle}>{strings.paymentAgreements.numberOfPayments}</p>
              <p className={style.tableContent}>{paymentAgreementState.numberOfPayments}</p>
            </div>

            <div className={style.bottomColumn}>
              <p className={style.tableTitle}>{strings.paymentAgreements.firstPaymentDate}</p>
              <p className={style.tableContent}>{formatDate(
                paymentAgreementState.firstPaymentDate ).replace( /\./g, "-" )}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
  render () {

    const { paymentAgreementState } = this.props
    const pickedInvoiceIds = paymentAgreementState.pickedInvoices.map( invoice => invoice.id )

    const preLitigationFilteredArray = this.props.debt.preLitigations.filter( preLitigation =>
      ( Object.values( paymentAgreementState.checkBoxes ).indexOf( preLitigation.id ) !== -1 ) )

    const litigationFilteredArray = this.props.debt.litigations.filter( litigation =>
      ( Object.values( paymentAgreementState.checkBoxes ).indexOf( litigation.id ) !== -1 ) )

    const preLitigationInvoices = preLitigationFilteredArray.map( preLitigation =>
      preLitigation.contracts.map( contract =>
        contract.invoices.filter( invoice => pickedInvoiceIds.includes( invoice.id ) ) ) )

    const litigationInvoices = litigationFilteredArray.map( litigation =>
      litigation.contracts.map( contract =>
        contract.invoices.filter( invoice => pickedInvoiceIds.includes( invoice.id ) ) ) )

    return (
      <div className={style.mainContainer}>
        {this.renderDebtor()}
        <h2 className={style.greyLineTitle}>{strings.paymentAgreements.agreedPaymentAgreementTitle.toUpperCase()}</h2>
        {this.renderPaymentInfo()}
        {this.renderPaymentAgreement()}
        <h2 className={style.greyLineTitle}>{strings.invoices.invoices.toUpperCase()}</h2>
        {this.renderInvoices( preLitigationFilteredArray, preLitigationInvoices,
          litigationFilteredArray, litigationInvoices )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/CreatePaymentAgreementPage/Verification/index.jsx